import React from 'react'
import { Loading } from '@myxplor/ui'

import { recordActionsToDisplay } from '../../ui/gov-actions'
import RecordDisplayList from '../../ui/record-display-list'

import LocalAsyncStore from '../../local-async-store'

import Empty from './empty'
import activate from './activate-action'

const serviceAddress = ({ Address }) =>
  [
    Address.results[0].streetLine1,
    Address.results[0].suburb,
    Address.results[0].postcode,
    Address.results[0].state,
  ]
    .filter(val => val)
    .join('\u000A')

const levelOneListFields = [
  {
    key: 'ServiceName.results.0.name',
    label: 'Name',
  },
  {
    key: 'serviceID',
    label: 'Service ID',
  },
  {
    key: 'serviceType',
    label: 'Service Type',
  },
  {
    key: 'CCSApproval.results.0.startDate',
    label: 'Start Date',
  },
  {
    label: 'Address',
    fn: serviceAddress,
  },
]

const levelTwoListFields = [
  {
    key: 'ACECQAExemptionReason',
    label: 'ACECQA Exemption Reason',
  },
]

const actionsForRecord = ({ record }) => {
  const activateAction = activate({ record })

  return [activateAction]
}

export const ServiceList = ({ service_registrations = { data: [], loading: false } }) => {
  let { loading, data } = service_registrations

  if (loading) return <Loading>Loading Service Registrations</Loading>
  if (data.length === 0) return <Empty />

  return (
    <RecordDisplayList
      {...{
        records: data,
        name: 'CCS Service Registration',
        level1: levelOneListFields,
        level2: levelTwoListFields,
        recordBase: 'gov_record',
        showRaw: true,
        actionButtonsComponent: recordActionsToDisplay({
          actionsForRecord,
        }),
      }}
    />
  )
}

const apiEndPoint = ({ provider_registration_id }) =>
  `/api/provider-registrations/${provider_registration_id}/service-registrations`

export default LocalAsyncStore('service_registrations', ServiceList, apiEndPoint)



// WEBPACK FOOTER //
// ./src/providers-registrations/service-list/index.jsx